<div class="multifroup-checkbox">
  <div [matMenuTriggerFor]="menu" [matMenuTriggerData]="{ data: groupsd }">
    <input id="groups" matInput placeholder="Select Groups" [value]="displayLabel" [readonly]="true" />
    <mat-icon class="check-mat-arrow" color="primary" fontIcon="arrow_drop_down"></mat-icon>
  </div>
</div>

<mat-menu #menu="matMenu" class="menu-checkbox-list">
  <ng-template matMenuContent let-groupdata="data">
    <div (click)="$event.stopPropagation()">
      @for (group of groupdata; track group) {
        <miq-checkboxgroup [group]="group" [parentComponent]="parentApi"></miq-checkboxgroup>
      }
    </div>
  </ng-template>
</mat-menu>
